import React, { useState } from "react";
import { Link } from "react-router-dom";

//
import { recovery } from "../../redux/features/user/actions";

//
import { Form, Button, Spinner } from "react-bootstrap";

//
import Account from "../../assets/img/user-images/account.png";

//
import ImageBox from "../../components/general/ImageBox";

//
import { Formik } from "formik";
import * as yup from "yup";
import GoogleRecaptchaModal from "../../components/auth/GoogleRecaptchaModal";

const schema = yup.object().shape({
  email: yup.string().email().required(),
});

const Recovery = () => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    email: "",
  });

  /**
   * Recover Password
   */
  const recover_pass = async (e) => {
    // close modal
    setShow(false);

    // start loading
    setLoading(true);

    // variables
    let content = { ...userData };
    content.recaptcha = e;

    // request
    await recovery(content);

    // stop loading
    setLoading(false);
  };

  const saveData = (e) => {
    let user_data = { ...userData };
    user_data.email = e.email;
    setUserData(user_data);
    setShow(true);
  };

  return (
    <>
      <GoogleRecaptchaModal
        show={show}
        setShow={(status) => setShow(status)}
        action={recover_pass}
      />

      <div>
        <ImageBox src={Account} />
        <h4>Reset your password</h4>

        <p>
          Enter the email address you used to sign up for Invalert, and we’ll
          send you a link to reset your password
        </p>

        <Formik
          validationSchema={schema}
          onSubmit={saveData}
          initialValues={{
            email: "",
          }}
        >
          {({ handleSubmit, handleChange, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group className="form-group" controlId="validationFormik0">
                <Form.Label>Your email</Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  placeholder="Enter your email"
                  className="form-control"
                  onChange={handleChange}
                  autoComplete="off"
                  isInvalid={touched.email && !!errors.email}
                  isValid={touched.email && !errors.email}
                />
              </Form.Group>

              <Button size="lg" type="submit" variant="info" className="w-100">
                Next
                {loading && (
                  <div className="spinner-holder">
                    <Spinner animation="border" variant="white" size="sm" />
                  </div>
                )}
              </Button>
            </Form>
          )}
        </Formik>
      </div>

      <small>
        Wanna login to your account?
        <Link to="/auth/login" className="text-info fw-bolder">
          Login now
        </Link>
      </small>
    </>
  );
};
export default Recovery;
